// extracted by mini-css-extract-plugin
export var container = "EventLocations-module--container--7a108";
export var layout = "EventLocations-module--layout--592cf";
export var subtitle = "EventLocations-module--subtitle--7ac6b";